
















import { Vue, Component, Prop } from 'vue-property-decorator';

import { ILocation } from '@/models/location';

import WebsiteIcon from '@/components/icons/Website2.vue';
import Typography from '@/componentsV2/atoms/Typography/Typography.vue';
import GroupedLocationsByCity from '@/componentsV2/organisms/GroupedLocationsByCity/GroupedLocationsByCity.vue';

@Component({
  components: {
    WebsiteIcon,
    Typography,
    GroupedLocationsByCity
  }
})
export default class LocationsAndWebsiteCard extends Vue {
  @Prop({ default: () => [] }) locations!: Array<ILocation>;
  @Prop({ default: '' }) website?: string;
}
